import { render, staticRenderFns } from "./leave-types.vue?vue&type=template&id=974b2f9c&"
import script from "./leave-types.vue?vue&type=script&lang=js&"
export * from "./leave-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports